// userPaymentStore.js
import { proxy } from "valtio";

const youtubeVideoProxy = proxy({
    video_url: "",
    show: false,
});

export default youtubeVideoProxy;
